import moment from "moment";
import { fetchProviderNotices } from "@/api/providerDashboard";
import noticesLifecycle from "@/controllers/noticesLifecycle";
import noticesPaginationMethods from "@/controllers/noticesPaginationMethods";
import createManagementShortDateMethods from "@shared/createManagementShortDateMethods.cjs";

const shortDateMethods = createManagementShortDateMethods({
  DateFormatter: moment,
});

export default {
  data() {
    return {
      notices: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      activeNotice: "",
      loading: true,
    };
  },
  ...noticesLifecycle,
  methods: {
    ...shortDateMethods,
    ...noticesPaginationMethods,
    async loadNotices() {
      this.loading = true;
      try {
        const res = await fetchProviderNotices({
          page: this.currentPage,
          limit: this.pageSize,
        });
        if (res.data.status === 200) {
          this.notices = res.data.data;
          this.total = res.data.total;
          this.activeNotice = "";
        } else {
          this.$message.error(
            res.data.message || "공지사항을 불러오지 못했습니다."
          );
        }
      } catch (err) {
        this.$message.error("공지사항을 불러오지 못했습니다.");
      } finally {
        this.loading = false;
      }
    },
  },
};
